import { render, staticRenderFns } from "./index.vue?vue&type=template&id=468bcee0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468bcee0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('468bcee0')) {
      api.createRecord('468bcee0', component.options)
    } else {
      api.reload('468bcee0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=468bcee0&scoped=true&", function () {
      api.rerender('468bcee0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Category/index.vue"
export default component.exports